<template>
  <div class="max-width-400px">
    <div class="card modal-card">
      <div class="modal-card-body pd-0">
        <header class="bandeau-modal card-header">
        </header>
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h1 class="title is-size-3">
                {{ $t('remiseBancaire.annulation.titre') }}
              </h1>
            </div>
          </div>
        </div>
        <div class="card-content">
          <div class="columns is-justify-content-center">
            <div class='column is-narrow'>
              <date-picker :dates="dates" />
            </div>
          </div>
          <footer>
            <b-field>
              <div class="is-pulled-left boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('general.button.cancel') }}
                </a>
              </div>
              <div class="is-pulled-left boutonAction">
                <a class="button is-addOrEdit" @click="exportToExcel()">
                  {{ $t('general.button.valider') }}
                </a>
              </div>
            </b-field>
          </footer>
        </div>
      </div>
    </div>
    <a ref="lienDownload"></a>
  </div>
</template>

<script>
import datePicker from '@/components/general/datePicker';
import exportExcel from '@/api/exportExcel/index';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import { EXPORT_EXCEL_REMISE_BANCAIRE_ANNULATION } from '@/configuration/remiseBancaire/remiseBancaireConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import moment from 'moment';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_exportExcelAnnulation',
  data() {
    return {
      dates: {
        dateDebut: (moment().startOf('month')).toDate(),
        dateFin: (moment().endOf('month')).toDate(),
      },
    };
  },
  components: {
    datePicker,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    async exportToExcel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: EXPORT_EXCEL_REMISE_BANCAIRE_ANNULATION,
          typeExport: '',
          filtres: {
            query: {
              dates: {
                dateDebut: formatIsoDate(this.dates.dateDebut),
                dateFin: formatIsoDate(this.dates.dateFin),
              },
              societeId: this.societeActiveId,
            },
          },
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.$parent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        loadingComponent.close();
        throw e;
      }
    },
  },
};
</script>

<style scoped></style>
